import { createFileRoute } from '@tanstack/react-router';
import { type AggregateBreadcrumb, buildBreadcrumb } from '@interxfi/app-components/components/router-breadcrumbs/router-breadcrumbs';
import { BATCH_ORDER_BASE_PATH } from '../../../../../../features/order/batch/batch-order-routing';

export const Route = createFileRoute('/_app/_clearing-core/order/equity/batch/_batch')({
  loader: () =>
    ({
      breadcrumb: buildBreadcrumb({
        id: 'equities-batch-order-list',
        label: 'Orders',
        to: BATCH_ORDER_BASE_PATH,
      }),
    }) satisfies AggregateBreadcrumb,
});
